import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Input } from "../components/ui/input";
import { Button } from "../components/ui/button";
import { toast } from "sonner";

export default function Login() {
    const { login } = useAuth();
    const nav = useNavigate();
    const [email, setEmail] = useState(""); const [password, setPassword] = useState(""); const [loading, setLoading] = useState(false);

    const submit = async (e) => {
        e.preventDefault(); setLoading(true);
        try {
            const u = await login(email, password);
            toast.success("Welcome back");
            nav(u.role === "admin" ? "/admin" : "/account");
        } catch { toast.error("Invalid credentials"); }
        setLoading(false);
    };

    return (
        <div data-testid="login-page" className="max-w-md mx-auto px-6 py-24">
            <div className="text-[11px] tracking-[0.4em] uppercase text-gold mb-3">Welcome Back</div>
            <h1 className="font-display text-4xl mb-10">Sign In</h1>
            <form onSubmit={submit} className="space-y-4">
                <Input aria-label="Email" required type="email" data-testid="login-email" value={email} onChange={e => setEmail(e.target.value)} placeholder="Email" className="bg-charcoal-800 border-[#E2D4C1] rounded-none focus-visible:ring-gold" />
                <Input aria-label="Password" required type="password" data-testid="login-password" value={password} onChange={e => setPassword(e.target.value)} placeholder="Password" className="bg-charcoal-800 border-[#E2D4C1] rounded-none focus-visible:ring-gold" />
                <Button type="submit" disabled={loading} data-testid="login-submit" className="w-full bg-gold hover:bg-gold-hover text-white rounded-none uppercase tracking-[0.2em] text-xs font-semibold py-5">{loading ? "Signing in…" : "Sign In"}</Button>
            </form>
            <div className="mt-6 flex justify-between text-xs uppercase tracking-widest text-[#6B645C]">
                <Link to="/register" className="hover:text-gold" data-testid="goto-register">Create Account</Link>
                <Link to="/reset" className="hover:text-gold" data-testid="goto-reset">Forgot Password</Link>
            </div>
        </div>
    );
}
